import { render } from "./StatsFilterPopUp.vue?vue&type=template&id=47a27487"
import script from "./StatsFilterPopUp.vue?vue&type=script&lang=js"
export * from "./StatsFilterPopUp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__